import { configureStore } from "@reduxjs/toolkit";
import localeSlice from "./features/locale/localeSlice";

export const store = configureStore({
	reducer: {
		locale: localeSlice,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});
